import {
  CheckCircleOutlineRoundedIcon,
  FormatListNumberedOutlinedIcon,
  SettingsOutlinedIcon,
  TimerOffOutlinedIcon,
  TimerOutlinedIcon,
  UnPublishedOutlinedIcon,
} from '@shared/components';

interface SettingsFormOption {
  value: 'true' | 'false';
  label: string;
}

export const MAPPED_WITH_TIMER_OPTIONS_ICON = {
  true: TimerOutlinedIcon,
  false: TimerOffOutlinedIcon,
};

export const MAPPED_SHOULD_SORT_BY_EXAM_SETTINGS_OPTIONS_ICON = {
  true: SettingsOutlinedIcon,
  false: FormatListNumberedOutlinedIcon,
};

export const MAPPED_SHOULD_DISPLAY_ANSWER_OPTIONS_ICON = {
  true: CheckCircleOutlineRoundedIcon,
  false: UnPublishedOutlinedIcon,
};

export const WITH_TIMER_OPTIONS: SettingsFormOption[] = [
  {
    value: 'true',
    label: 'จับเวลา',
  },
  {
    value: 'false',
    label: 'ไม่จับเวลา',
  },
];

export const SHOULD_SORT_BY_EXAM_SETTINGS_OPTIONS: SettingsFormOption[] = [
  {
    value: 'true',
    label: 'ตามการตั้งค่าชุดข้อสอบ',
  },
  {
    value: 'false',
    label: 'เรียงตามลำดับ',
  },
];

export const SHOULD_DISPLAY_ANSWER_OPTIONS: SettingsFormOption[] = [
  {
    value: 'false',
    label: 'ไม่แสดงเฉลย',
  },
  {
    value: 'true',
    label: 'แสดงเฉลย',
  },
];
